<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>记账对账</el-breadcrumb-item>
				<el-breadcrumb-item>会计交接记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-date-picker
						type="month"
						placeholder="期号"
						v-model="query.period"
						value-format="yyyy-MM"
				></el-date-picker>&nbsp;
				<el-select v-model="query.status" placeholder="状态">
					<el-option key="" label="请选择" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="period" label="期号"></el-table-column>
                <el-table-column prop="reportConfigId" label="记账类型" :formatter="reportConfigFormat"></el-table-column>
				<el-table-column prop="startDate" label="日期段" width="360">
					<template slot-scope="scope">
						{{scope.row.startDate}} 至 {{scope.row.endDate}}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormat"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete'] && scope.row.status < 2"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加新纪录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-form-item label="期号" prop="period">
					<el-date-picker
							type="month"
							placeholder="年月"
							v-model="form.period"
							value-format="yyyy-MM"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="开始日期" prop="startDate">
					<el-date-picker
						type="date"
						placeholder="开始日期"
						v-model="form.startDate"
						value-format="yyyy-MM-dd"
					></el-date-picker>
				</el-form-item>
                <el-form-item label="备注">
					<el-input type=textarea :rows=5 v-model="form.remark"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 预览 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" fullscreen>
			<el-button style="float:left" icon="el-icon-s-claim" type="primary" @click="saveImport"  v-if="controll['import']" v-prevent-re-click>保存</el-button>
			<div style="text-align:right;padding-bottom:10px;">
				<el-input class="handle-input mr10"
					placeholder="输入关键字进行过滤"
					v-model="filterText">
				</el-input>
			</div>
			<el-table
				:data="subjectBanlanceData.filter(data => !filterText || data.accountingCode.includes(filterText.toLowerCase()) || data.accountingName.includes(filterText.toLowerCase()))"
				style="width: 100%;margin-bottom: 20px;"
				row-key="accountingCode"
				border
				size="medium"
				default-expand-all
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="accountingCode" label="科目编码" width="180"></el-table-column>
				<el-table-column prop="accountingName" label="科目名称" width="300"></el-table-column>
				<el-table-column label="期初余额" align="center">
					<el-table-column prop="preDebit" label="借方">
					</el-table-column>
					<el-table-column prop="preCredit" label="贷方">
					</el-table-column>
				</el-table-column>
				<el-table-column label="本期发生额" align="center">
					<el-table-column prop="debit" label="借方">
					</el-table-column>
					<el-table-column prop="credit" label="贷方">
					</el-table-column>
				</el-table-column>
				<el-table-column label="本年累计发生额" align="center">
					<el-table-column prop="yearDebit" label="借方">
					</el-table-column>
					<el-table-column prop="yearCredit" label="贷方">
					</el-table-column>
				</el-table-column>
				<el-table-column label="期末余额" align="center">
					<el-table-column prop="terDebit" label="借方">
					</el-table-column>
					<el-table-column prop="terCredit" label="贷方">
					</el-table-column>
				</el-table-column>
			</el-table>
        </el-dialog>
		
		<!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false title="添加内容项" :visible.sync="editItemVisible" width="40%">
            <el-form ref="formItem" :model="formItem" label-width="80px" :rules="itemRules">
				<el-form-item label="科目编码" prop="accountingDetail">
					<el-cascader
						:options="accountingCodeOptions"
						v-model="formItem.accountingDetail" filterable clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="科目名称" prop="name">
					<el-input v-model="formItem.name"></el-input>
				</el-form-item>
				<el-descriptions title="" direction="vertical" :column="1" border>
					 <el-descriptions-item label="期初余额">
						<el-col :span="12">
								<el-form-item label="借方" prop="preDebit">
									<el-input v-model="formItem.preDebit"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="贷方" prop="preCredit">
									<el-input v-model="formItem.preCredit"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					 </el-descriptions-item>
					 <el-descriptions-item label="本期发生额">
						<el-col :span="12">
								<el-form-item label="借方" prop="debit">
									<el-input v-model="formItem.debit"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="贷方" prop="credit">
									<el-input v-model="formItem.credit"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					 </el-descriptions-item>
					 <el-descriptions-item label="本年累计发生额">
						<el-col :span="12">
								<el-form-item label="借方" prop="yearDebit">
									<el-input v-model="formItem.yearDebit"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="贷方" prop="yearCredit">
									<el-input v-model="formItem.yearCredit"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					 </el-descriptions-item>
					 <el-descriptions-item label="期末余额">
						<el-row>
							<el-col :span="12">
								<el-form-item label="借方" prop="terDebit">
									<el-input v-model="formItem.terDebit"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="贷方" prop="terCredit">
									<el-input v-model="formItem.terCredit"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					 </el-descriptions-item>
				</el-descriptions>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editItemVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveItem" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<!-- 详情 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="showVisible" fullscreen>
			<el-upload
				style="float:left"
				class="upload-demo mr10"
				accept=".xls,.xlsx"
				action= "/blob/accounting-report/import-excel"
				:on-success="uploadSuccess"
				:file-list="fileList"
				:show-file-list = "false"
				v-if="controll['import'] && this.form['status'] == 1"
				list-type="picture">
				<el-button size="small" type="primary" icon="el-icon-folder-add" v-if="controll['import'] && this.form['status'] == 1">导入交接内容</el-button>
			</el-upload>
			<el-button
					style="float:left"
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleItemAdd"
					v-if="controll['add'] && this.form['status'] == 1"
                >添加新纪录</el-button>			
			<el-button style="float:left" icon="el-icon-check" type="primary" @click="handleCheck"  v-if="controll['check'] && this.form['status'] == 1" v-prevent-re-click>审核</el-button>
			<div style="text-align:right;padding-bottom:10px;">
				<el-input class="handle-input mr10"
					placeholder="输入关键字进行过滤"
					v-model="datasourceFilterText">
				</el-input>
			</div>
			<el-table
				:data="datasource.filter(data => !datasourceFilterText || data.accountingCode.includes(datasourceFilterText.toLowerCase()) || data.accountingName.includes(datasourceFilterText.toLowerCase()))"
				style="width: 100%;margin-bottom: 20px;"
				row-key="accountingCode"
				border
				size="medium"
				default-expand-all
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="accountingCode" label="科目编码" width="180"></el-table-column>
				<el-table-column prop="accountingName" label="科目名称" width="300"></el-table-column>
				<el-table-column label="期初余额" align="center">
					<el-table-column prop="preDebit" label="借方">
						<template slot-scope="scope">
							{{scope.row.preDebit?scope.row.preDebit:"0"}}
						</template>
					</el-table-column>
					<el-table-column prop="preCredit" label="贷方">
						<template slot-scope="scope">
							{{scope.row.preCredit?scope.row.preCredit:"0"}}
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column label="本期发生额" align="center">
					<el-table-column prop="debit" label="借方">
						<template slot-scope="scope">
							{{scope.row.debit?scope.row.debit:"0"}}
						</template>
					</el-table-column>
					<el-table-column prop="credit" label="贷方">
						<template slot-scope="scope">
							{{scope.row.credit?scope.row.credit:"0"}}
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column label="本年累计发生额" align="center">
					<el-table-column prop="yearDebit" label="借方">
						<template slot-scope="scope">
							{{scope.row.yearDebit?scope.row.yearDebit:"0"}}
						</template>
					</el-table-column>
					<el-table-column prop="yearCredit" label="贷方">
						<template slot-scope="scope">
							{{scope.row.yearCredit?scope.row.yearCredit:"0"}}
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column label="期末余额" align="center">
					<el-table-column prop="terDebit" label="借方">
						<template slot-scope="scope">
							{{scope.row.terDebit?scope.row.terDebit:"0"}}
						</template>
					</el-table-column>
					<el-table-column prop="terCredit" label="贷方">
						<template slot-scope="scope">
							{{scope.row.terCredit?scope.row.terCredit:"0"}}
						</template>
					</el-table-column>
				</el-table-column>
				<el-table-column label="操作" width="120" align="center" v-if="this.form['status'] == 1">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleItemDelete(scope.$index, scope.row)"
							v-if="controll['delete'] && !scope.row.children"
                        >删除</el-button>
                    </template>
                </el-table-column>
			</el-table>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchHandoverData, saveAccountingReport, deleteAccountingReport, getAccountingReport, 
getAccountingReportConfigKV, getHandoverMonthTotal, saveHandoverBatch, saveHandoverItem, 
deleteHandoverItem, getAllAccountingCode, checkHandover} from '../../../api/index';
export default {
    name: 'handover',
    data() {
		let checkNum = (rule, value, callback) => {
			const mailReg = /^[0-9]*$/
			if (value) {
				if (mailReg.test(value)) {
					callback()
				} else {
					callback(new Error('编码为数值型'));
				}
			} else {
				callback(new Error('请输入编码'));
			}
		}
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
			reportConfigKV:[],
            tableData: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			show: {},
            idx: -1,
            id: -1,
			title:"",
			showVisible:false,
			salaryData:[],
			summaryData:[],
			reimburseData:[],
			filterText:"",
			datasourceFilterText:"",
			datasource:[],
			fileList:[],
			formItem:{},
			editItemVisible:false,
			uuid:"",
			subjectBanlanceData:[],
			accountingCodeOptions:[],
			previewVisible:false,
			rules: {
				period: [{ required: true, message: '请选择期号', trigger: 'blur' }],
				startDate: [{ required: true, message: '请选择开始日期', trigger: 'blur' }]
            },
			itemRules: {
				accountingDetail: [{ required: true, message: '请选择科目编码', trigger: 'blur' }],
				name: [{ required: true, message: '请输入科目名称', trigger: 'blur' }]
            },
			controll:{},
			statusKV:[{"key":0, "value":"待审核"}, {"key":2, "value":"审核完成"}],
        };
    },
    created() {
		this.controll = getControll("handover");
		this.getAccountingCode();
		this.getConfigKV();
        this.getData();
    },
    methods: {
        // 获取财务报表数据
        getData() {
            fetchHandoverData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
		//获取产品信息
		getAccountingCode() {
			getAllAccountingCode(this.form).then(res => {
				if (res.code == 0) {
					this.accountingCodeOptions = res.data;
				} else {
					this.$message.error(`获取会计代码失败！` + res.message);
				}
			})
		},
		//获取财务报表类型
		getConfigKV() {
			getAccountingReportConfigKV().then(res=>{
				if (res.code == 0 ) {
					this.reportConfigKV = res.data;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		statusFormat(row, column, cellValue){
			let index = this.statusKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.statusKV[index].value;
		},
		reportConfigFormat(row, column, cellValue){
			let index = this.reportConfigKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return (row.quarter?("Q"+row.quarter):"") + this.reportConfigKV[index].value;
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccountingReport([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.form["reportConfigId"] = 8;
			this.title = "添加新纪录";
			this.editVisible = true;
		},
		handleItemAdd() {
			this.formItem = {};
			this.editItemVisible = true;
		},
        // 编辑操作
        handleShow(index, row) {
			getHandoverMonthTotal(row.id).then(res => {
				if (res.code == 0 ) {
					this.title = "详情";
					this.datasource = res.data;
					this.showVisible = true;
					this.form = row;
					this.id = row.id;
				} else {
					this.$message.error(res.message);
				}
			})
        },
		// 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					this.form["startDate"] = this.form["startDate"] + " 00:00:00";
					saveAccountingReport(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		//保存内容项
		saveItem() {
			this.$refs.formItem.validate(valid => {
				if (valid) {
					this.formItem["accountingCode"] = this.formItem["accountingDetail"][this.formItem["accountingDetail"].length - 1];
					this.formItem["reportId"] = this.id;
					saveHandoverItem(this.formItem).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editItemVisible = false;
							getHandoverMonthTotal(this.id).then(res => {
								if (res.code == 0 ) {
									this.datasource = res.data;
								} else {
									this.$message.error(res.message);
								}
							})
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
		},
        // 导出报表
        handleExport(index, row){
			exportAccountingReportById(row.id).then(res => {
				if (res.code == 0) {
					this.$router.push({path: "export-bookkeeping", query:{code:5, key: res.data}});
				} else {
					this.$message.error(`导出报表失败！` + res.message);
				}
			});
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		uploadSuccess(response, file, fileList) {
			if (response.code == 0 ) {
				this.subjectBanlanceData = response.data.obj;
				this.uuid = response.data.uuid;
				this.previewVisible = true;
			} else {
				this.$message.error(response.message);
			}
		},
		saveImport(){
			this.$confirm('确定要保存吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let param = {};
					param["key"] = this.id;
					param["value"] = this.uuid;
					saveHandoverBatch(param).then(res => {
						if (res.code == 0) {
							getHandoverMonthTotal(this.id).then(res => {
								if (res.code == 0 ) {
									this.previewVisible = false;
									this.datasource = res.data;
								} else {
									this.$message.error(res.message);
								}
							})
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		},
		// 删除操作
        handleItemDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除[' + row.accountingCode + '-' + row.accountingName + ']吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteHandoverItem([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							getHandoverMonthTotal(this.id).then(res => {
								if (res.code == 0 ) {
									this.datasource = res.data;
								} else {
									this.$message.error(res.message);
								}
							})
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		handleCheck() {
			this.$confirm('确定审核会计交接内容吗？审核后，会计交接内容将被锁定，不可更改！', '提示', {
                type: 'warning'
            })
                .then(() => {
					checkHandover(this.id).then(res => {
						if (res.code == 0) {
							this.$message.success('审核成功');
							this.showVisible = false;
							this.getData();
						} else {
							this.$message.error(`审核失败！` + res.message);
						}
					});
                })
                .catch(() => {});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

/deep/ .el-table .warning-row {
	background: #fafafa;
	font-size:14px;
}

</style>
